var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-ais',{attrs:{"image":_vm.image}})
}
var staticRenderFns = []

export { render, staticRenderFns }